import { create } from 'zustand';
import type { Deal } from './types';

/**
 * Estado global do drawer da ficha do Deal (E6). Guarda o Deal da listagem clicado, então o
 * drawer renderiza na hora; o detalhe extra (resumo, tags, pasta) é buscado por GET dentro do
 * drawer. Global (zustand) porque o clique pode vir do kanban, da tabela ou da sidebar.
 */
interface DealDrawerState {
  deal: Deal | null;
  openDeal: (deal: Deal) => void;
  closeDeal: () => void;
}

export const useDealDrawer = create<DealDrawerState>()((set) => ({
  deal: null,
  openDeal: (deal) => set({ deal }),
  closeDeal: () => set({ deal: null }),
}));
